export default __webpack_public_path__ + "static/silverXlCover-95c7bfdbb60803f5cb7173425c396fa0.png";